<h2>Orders for {{inst.name}}</h2>

<mat-spinner *ngIf="updating"></mat-spinner>

<div class="button_row" *ngIf="!updating">
    <button mat-raised-button color="primary" (click)="addNew()">Add New</button>
    <button mat-raised-button (click)="back()">Back</button>
</div>

<div *ngIf="instOrders?.length && !updating" class="paginator_row">
    <mat-paginator #paginator
                   [hidden]="updating"
                   [length]="instOrders?.length"
                   [pageIndex]="INITIAL_PAGE_INDEX"
                   [pageSize]="INITIAL_PAGE_SIZE"
                   [pageSizeOptions]="[5, 10, 20]"
                   (page)="pageChanged($event)"></mat-paginator>
</div>
<table mat-table *ngIf="instOrders?.length && !updating"
       [dataSource]="orderRange">

    <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let order">{{formatDate(order.created)}}</td>
    </ng-container>

    <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Code</th>
        <td mat-cell *matCellDef="let order" [ngClass]="{promo_disabled: order.promo_disabled}">{{order.promo_code}}</td>
    </ng-container>

    <ng-container matColumnDef="expires">
        <th mat-header-cell *matHeaderCellDef>Expires</th>
        <td mat-cell *matCellDef="let order">{{formatDate(order.promo_expires)}}</td>
    </ng-container>

    <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef>Count</th>
        <td mat-cell *matCellDef="let order">{{order.unit_count}}</td>
    </ng-container>

    <ng-container matColumnDef="left">
        <th mat-header-cell *matHeaderCellDef>Left</th>
        <td mat-cell *matCellDef="let order">{{order.promo_inventory}}</td>
    </ng-container>

    <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell class="total" *matCellDef="let order">{{order.total | currency}}</td>
    </ng-container>

    <ng-container matColumnDef="paid">
        <th mat-header-cell *matHeaderCellDef>Paid</th>
        <td mat-cell *matCellDef="let order">{{formatDate(order.paid)}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell class="action_buttons" *matCellDef="let order">
            <mat-icon class="link" (click)="edit(order)" title="Edit">edit</mat-icon>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row
        *matRowDef="let inst; columns: columnsToDisplay"></tr>

</table>

